﻿(function ($, document) {
    $(document).ready(function () {
        $('.js-radio-card input[type=radio]').click(function () {
            $('.js-radio-card input[type=radio]').prop('checked', false);
            $(this).prop('checked', true);
        });

    });
})(jQuery, document);